import { Box, Heading, Button, Stack, Center, Text, Container, Flex, IconButton, Dialog, Portal, Field, Input } from '@chakra-ui/react'
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CiEdit } from "react-icons/ci";



function verifySession(navigate) {
	function navToLogin() {
		navigate('/Login');
	}
	const sessionToken = localStorage.getItem('sessionToken');
	if (sessionToken) {
		const url = new URL('/api/auth/sessionVerify', window.location.origin);
		url.searchParams.append('token', sessionToken);

		fetch(url, {
			method: 'GET',
			headers: { Accept: 'application/json' },
		})
			.then((response) => response.json())
			.then((data) => {
				if (data.expired == true) {
					// Token is expired; navigate to the login page
					console.log('Session expired, please log in again.');
					navToLogin();
				}
			})
			.catch((error) => {
				console.error('Error verifying session: ', error);
			});
	}
}



const EditAccount = () => {
    const [accountOpen, setAccountOpen] = useState(true);
    const [systemOpen, setSystemOpen] = useState(false);
    const [notificationOpen, setNotificationOpen] = useState(false);
    const [helpOpen, setHelpOpen] = useState(false);
    const [displayEdit, setDisplayEdit] = useState(false)
    const [currentType, setCurrentType] = useState("")
    const [currentValue, setCurrentValue] = useState("")
    const [editValue, setEditValue] = useState()
    const navigate = useNavigate();

    useEffect(() => {
        verifySession(navigate);
    }, []);

    const [user, setUser] = useState({
        fullName: "Missing Name",
        dob: "Missing dob",
        email: "Missing email",
        displayName: "Missing displayname",
        password: "********"
    })

    const handleDisplayEdit = (type, value) => {
        setDisplayEdit(!displayEdit)
        setCurrentType(type)
        setCurrentValue(value)
    }

    const handleEditSubmit = () => {
        switch(currentType){
            case 'Full Name': user.fullName = editValue;
                break;
            case 'Date of Birth': user.dob = editValue
                break;
            case 'Email': user.email = editValue
                break;
            case 'Display Name': user.displayName = editValue
        }
        setDisplayEdit(!displayEdit);
        setUserData();
    }

    const handleAccountOpen = () => {
        if(!accountOpen){
            setAccountOpen(!accountOpen);
            setSystemOpen(accountOpen);
            setNotificationOpen(accountOpen);
            setHelpOpen(accountOpen);
        }
    }

    const handleSystemOpen = () => {
        if(!systemOpen){
            setSystemOpen(!systemOpen);
            setAccountOpen(systemOpen);
            setNotificationOpen(systemOpen);
            setHelpOpen(systemOpen);
        }
    }

    const handleNotificationOpen = () => {
        if(!notificationOpen){
            setNotificationOpen(!notificationOpen);
            setAccountOpen(notificationOpen);
            setSystemOpen(notificationOpen);
            setHelpOpen(notificationOpen);
        }
    }

    const handleHelpOpen = () => {
        if(!helpOpen){
            setHelpOpen(!helpOpen);
            setAccountOpen(helpOpen);
            setSystemOpen(helpOpen);
            setNotificationOpen(helpOpen);
        }
    }

    useEffect(() => {
        const sessionToken = localStorage.getItem('sessionToken');
        const url = new URL('/api/user/info/getUserInfo', window.location.origin); 

        fetch(url, { 
        method: 'GET', 
        headers: { 
            Accept: 'application/json',
            Authorization: `Bearer ${sessionToken}`,
        }
        }) 
        .then(response => response.json()) 
        .then (data => {
            setUser({...user, fullName: (data.fullName || user.fullName), dob: (data.dob || user.dob), email: (data.email || user.email), displayName: (data.displayName || user.displayName)})
        }) 
        .catch(error => { 
            console.error("Error retrieving user data: ", error); 
        }); 
    },[]);

    function setUserData() {
        const sessionToken = localStorage.getItem('sessionToken');
        const url = new URL('/api/system/user/user', window.location.origin); 


        fetch(url, { 
        method: 'POST', 
        headers: { 
            Accept: 'application/json',
            Authorization: `Bearer ${sessionToken}`,
        },
        body: JSON.stringify({
            fullName: user.fullName,
            email: user.email,
            username: user.displayName,
            birthdate: user.dob,
            active: true,
        })
        }) 
        .then(response => response.json()) 
        .then(data => { 
            console.log('user updated')
        }) 
        .catch(error => { 
            console.error("Error setting user data: ", error); 
        }); 
    }

  return (
    <>
    <Box w={'calc(100vw * 5/6)'} marginLeft={'calc(100vw * 1/6)'} h={'calc(100vh * 11/12)'} marginTop={'calc(100vh * 1/12)'}>
        <Box maxW={'1/6'} h={'full'} bg={'white'} pos={'fixed'}>
            <Center>
                <Heading fontSize={'3xl'} fontFamily={'Esteban'} margin={12} color={'black'}>
                    Settings
                </Heading>
            </Center>
            <Stack gap={0}>
                <Button bg={accountOpen ? '#465362' : 'white'} borderBottom={'1px solid black'} color={accountOpen ? 'white' : 'black'} fontSize={'xl'} _hover={{bg: "gray.200"}}
                    onClick={handleAccountOpen}>
                    Account
                </Button>
                <Button bg={systemOpen ? '#465362' : 'white'} borderBottom={'1px solid black'} color={systemOpen ? 'white' : 'black'} fontSize={'xl'} _hover={{bg: "gray.200"}}
                    onClick={handleSystemOpen}>
                    System
                </Button>
                <Button bg={notificationOpen ? '#465362' : 'white'} borderBottom={'1px solid black'} color={notificationOpen ? 'white' : 'black'} fontSize={'xl'} _hover={{bg: "gray.200"}}
                    onClick={handleNotificationOpen}>
                    Notifications
                </Button>
                <Button bg={helpOpen ? '#465362' : 'white'} borderBottom={'1px solid black'} color={helpOpen ? 'white' : 'black'} fontSize={'xl'} _hover={{bg: "gray.200"}}
                    onClick={handleHelpOpen}>
                    Help
                </Button>
            </Stack>
        </Box>
        {accountOpen && (
            <Box bg={'gray.200'} w={'5/6'} h={'full'} float={'right'} overflow={'scroll'}>
                <Center>
                    <Heading color={'#011936'} fontSize={'4xl'} margin={8}>
                        Account Info
                    </Heading>
                </Center>
                <Box bg={'white'} rounded={'4xl'} marginX={'auto'} marginY={12} p={4} w={'3/4'}>
                    <Stack gap={4} margin={8}> 
                        <Heading fontSize={'2xl'} color={'black'}>
                            Basic Info
                        </Heading>
                        <Flex w={'full'} justifyContent={'space-between'} fontSize={'lg'} borderBottom={'1px solid black'} align={'center'}>
                            <Text color={'black'} w={'1/4'}>
                                Full Name:
                            </Text>
                            <Text color={'black'}  w={'1/2'}  textAlign={'center'}>
                                {user.fullName}
                            </Text>
                            <IconButton bg={'#F9DC5C '} color={'black'} onClick={() => handleDisplayEdit("Full Name", user.fullName)} cursor={'pointer'}>
                                <CiEdit />
                            </IconButton>
                        </Flex>
                        <Flex w={'full'} justifyContent={'space-between'} fontSize={'lg'} borderBottom={'1px solid black'}>
                            <Text color={'black'} w={'1/4'}>
                                Date of Birth:
                            </Text>
                            <Text color={'black'}  w={'1/2'}  textAlign={'center'}>
                                {user.dob}
                            </Text>
                            <IconButton bg={'#F9DC5C '} color={'black'} onClick={() => handleDisplayEdit("Date of Birth", user.dob)} cursor={'pointer'}>
                                <CiEdit />
                            </IconButton>
                        </Flex>
                        <Flex w={'full'} justifyContent={'space-between'} fontSize={'lg'} borderBottom={'1px solid black'} >
                            <Text color={'black'} w={'1/4'}>
                                Display Name:
                            </Text>
                            <Text color={'black'}  w={'1/2'}  textAlign={'center'}>
                                {user.displayName}
                            </Text>
                            <IconButton bg={'#F9DC5C '} color={'black'} onClick={() => handleDisplayEdit("Display Name", user.displayName)}cursor={'pointer'}>
                                <CiEdit />
                            </IconButton>
                        </Flex>
                    </Stack>
                    <Stack gap={8} margin={8}> 
                        <Heading fontSize={'3xl'} marginTop={8} color={'black'}>
                            Account Info
                        </Heading>
                        <Flex w={'full'} justifyContent={'space-between'} fontSize={'lg'} borderBottom={'1px solid black'}>
                            <Text color={'black'} w={'1/4'}>
                                Email
                            </Text>
                            <Text color={'black'}  w={'1/2'}  textAlign={'center'}>
                                {user.email}
                            </Text>
                            <IconButton bg={'#F9DC5C '} color={'black'} onClick={() => handleDisplayEdit("Email", user.email)} cursor={'pointer'}>
                                <CiEdit />
                            </IconButton>
                        </Flex>
                        <Flex w={'full'} justifyContent={'space-between'} fontSize={'lg'} borderBottom={'1px solid black'}>
                            <Text color={'black'} w={'1/4'}>
                                Password:
                            </Text>
                            <Text color={'black'}  w={'1/2'}  textAlign={'center'}>
                                {user.password}
                            </Text>
                            <IconButton bg={'#F9DC5C '} color={'black'} onClick={() => handleDisplayEdit("Password", "********")} cursor={'pointer'}>
                                <CiEdit />
                            </IconButton>
                        </Flex>
                    </Stack>
                    {displayEdit && (
                        <Dialog.Root placement={'top'} size={'lg'} open={displayEdit} lazyMount>
                            <Portal>
                                <Dialog.Backdrop />
                                <Dialog.Positioner>
                                    <Dialog.Content color={'black'}>
                                        <Dialog.Header>
                                            <Dialog.Title>Edit {currentType}</Dialog.Title>
                                        </Dialog.Header>
                                        <Dialog.Body pb="4">
                                            <Stack gap="4">
                                                <Field.Root>
                                                    {(currentType == 'Password') && (
                                                        <>
                                                        <Text>Can't Edit right now</Text>
                                                        <Field.Label>{'Current Password'}</Field.Label>
                                                        <Input placeholder={'Enter current Password'} onChange={(e) => {setEditValue(e.target.value)}} disabled />
                                                        <Field.Label>{'Current Password'}</Field.Label>
                                                        <Input placeholder={'Enter new Password'}  onChange={(e) => {setEditValue(e.target.value)}} disabled />
                                                        </>
                                                    )}
                                                    {(currentType == 'Date of Birth') && (
                                                        <>
                                                        <Field.Label>{currentType}</Field.Label>
                                                        <Text>Current: {currentValue} </Text>
                                                        <Input defaultValue={editValue} type='date' onChange={(e) => {setEditValue(e.target.value)}} />
                                                        </>
                                                    )}
                                                    {(currentType == 'Email') && (
                                                        <>
                                                        <Field.Label>{currentType}</Field.Label>
                                                        <Text>Currently can't change email</Text>
                                                        <Input placeholder={currentValue} defaultValue={currentValue} onChange={(e) => {setEditValue(e.target.value)}} disabled />
                                                        </>
                                                    )}
                                                    {currentType != 'Password' && currentType != 'Date of Birth' && currentType != 'Email' &&(
                                                        <>
                                                        <Field.Label>{currentType}</Field.Label>
                                                        <Input placeholder={currentValue} defaultValue={currentValue} onChange={(e) => {setEditValue(e.target.value)}} />
                                                        </>
                                                    )}
                                                </Field.Root>
                                            </Stack>
                                        </Dialog.Body>
                                        <Dialog.Footer>
                                            <Dialog.ActionTrigger asChild>
                                                <Button variant="outline" onClick={handleDisplayEdit}>Cancel</Button>
                                            </Dialog.ActionTrigger>
                                            <Button  onClick={handleEditSubmit}>Save</Button>
                                        </Dialog.Footer>
                                    </Dialog.Content>
                                </Dialog.Positioner>
                            </Portal>
                        </Dialog.Root>
                    )}
                </Box>
            </Box>
        )}
    </Box>
    </>
  )
}

export default EditAccount